import script from "./MiNTProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTProgress.vue?vue&type=script&setup=true&lang=js"

import "./MiNTProgress.vue?vue&type=style&index=0&id=622ab360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622ab360"]])

export default __exports__